import { createFileRoute, redirect, useParams } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'
import { PDFViewerPage } from '@/components/pdf-viewer/PDFViewerPage'
import { LoadingDocumentPage } from '@/components/loading-ui/LoadingDocumentPage'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/projects/$projectId/document/$docId',
)({
  component: RouteComponent,
  pendingComponent: () => <LoadingDocumentPage />,
})

function RouteComponent() {
  const { orgId, projectId, docId } = useParams({
    from: '/_authenticated/org/$orgId/projects/$projectId/document/$docId',
  })

  const store = useSelectedTenantStore()
  const TENANT_ID = store.selectedTenantId

  if (!TENANT_ID) {
    throw redirect({ to: '/select-tenant' })
  }

  return (
    <PDFViewerPage documentId={docId} tenantId={orgId} projectId={projectId} />
  )
}
